window.BlockWork = () => {
    return {
        // eslint-disable-next-line no-undef
        ajax_url: ajax_object.ajax_url,
        page: 1,
        posts: [],
        initWork() {
            this.getPosts();
        },
        resetPosts() {
            this.page = 1;
            this.posts = [];
        },
        getPosts() {
            fetch(this.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'get_work',
                    paged: this.page,
                }),
            }).then((response) => response.json())
                .then((data) => {
                    this.posts = this.posts.concat(data);
                })
                .catch((error) => console.log(error));
            
            this.page++
        
        },
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Work.js